import { TourStep } from '../../models/tour.model';

export const NOTES_PAGE_TOUR: TourStep[] = [
  {
    title: 'All Notes in One Place',
    element: '.sidenav-content semeris-sidenav-item#menu-item-notes',
    position: 'right',
    intro: `
      <p>Access all your notes here in one-place to:</p>
      <ul>
         <li><b>Review</b></li>
         <li><b>Filter</b></li>
         <li><b>Collaborate</b></li>
         <li><b>Export</b></li>
      </ul>
      <p><i>Let's dive in!</i></p>
    `,
  },
  {
    title: `List of All Your Team's Notes`,
    element: 'semeris-conversation-activity-item',
    intro: `
          <p>Here, your notes are presented in a distinct <b>horizontal layout</b>:</p>
          <ul>
              <li><b>Horizontal layout</b> - Note blocks are arranged side-by-side, reminiscent of rows in Excel. This allows you to view more notes at once.</li>
              <li><b>Vertical layout</b> - In other parts of the system, note blocks are stacked above/below each other, which is more conducive to discussions.</li>
          </ul>
          <p>Both layouts offer the same functionality, including <b>editing</b> and <b>discussions</b>.</p>
      `,
  },
  {
    title: 'Searching In Your Notes',
    element: 'semeris-search-input mat-form-field',
    intro: `
        <p>Use the <b>search box</b> to find notes with specific phrases in the notes and discussions.</p>
    `,
  },
  {
    title: 'Filter Your Notes',
    element: 'semeris-conversation-list-container div.filters-panel',
    intro: `
      <p>All notes from <b>you and your team</b> are here.</p>
      <p><b>Filter</b> them by:</p>
      <ul>
         <li><b>Date</b> - create and update</li>
         <li><b>People</b> - creator, participants, assignees</li>
         <li><b>Attributes</b> - labels and context</li>
      </ul>
    `,
  },
  {
    title: 'Save Your Note Filters',
    element: 'semeris-conversation-filter-selector',
    intro: `
      <p>You can <b>save your filters</b> for quicker access in the future.</p>
      <p>This allows you to manage <b>multiple projects</b>, or <b>review past work</b> with ease.</p>
    `,
  },
  {
    title: 'Export Your Notes',
    element: 'button.export-button',
    intro: `
        <p>Once you've set your desired filters, you can <b>export notes</b> into various document formats.</p>

        <p>Semeris Notes offers exports in:</p>
        <ul>
            <li>CSV</li>
            <li>Excel</li>
            <li>Word</li>
            <li>HTML</li>
        </ul>
                
        <p>Use the Preview feature to view the format before finalizing the export.</p>

        <p>The <b>X-Ray formatting</b> from your gathered documents is retained in Word exports, but it's optional.</p>
    `,
  },
  {
    title: 'Auto-added Labels',
    element: 'semeris-default-label-selector',
    intro: `
        <p>Labels enhance the <b>organization</b> of your notes.</p>
        <p>Use the <i class="material-icons">label</i> icon to manage your <b>auto-added</b> labels.</p>
        <p>For instance, you can select case, project, or counterparty labels that get assigned to every new note while you work on a review task.</p>
    `,
  },
  {
    title: 'Welcome to Semeris Notes',
    intro: `
        <p>Semeris Notes is a flexible system offering powerful collaborative note-taking.</p>
        <p>Your notes are seamlessly integrated with:</p>
        <ul>
          <li><b>Documents</b></li>
          <li><b>Data</b></li>
          <li><b>Comparisons</b></li>
          <li><b>Blacklines</b></li>
          <li>and more</li>
        </ul>
        <p>Remember the icons:</p>
        <ul>
          <li><i class="material-icons">add_comment</i> - to create a new note.</li>
          <li><i class="material-icons" style="color: var(--semeris-blue);">mode_comment</i> - for reviewing related notes.</li>
        </ul>
        <p><i>You're all set! Let's start taking notes.</i></p>
    `,
  },
];
